
import Icon from '@/components/UntitledUI/Icon.vue'

export default {
    components: {
        Icon
    },
    middleware: ['isTenantOwner'],
    async asyncData ({
        params,
        $axios,
        $auth,
        redirect,
        app
    }) {
        if ($auth.user.is_trail && !$auth.user.is_subscribe) {
            return redirect(app.localePath('/'))
        }

        const limit = 2

        let currentSubscription = await $axios.get('v1/CurrentSubscription')
        let subscriptions = await $axios.get('v1/Subscriptions?limit=' + limit)
        let cards = await $axios.get('v1/Card')

        return {
            limit,
            subscription: currentSubscription.data,
            subscriptions: subscriptions.data.data,
            total: subscriptions.data.total,
            cards: cards.data
        }
    },
    data () {
        return {
            subscription: null,
            loading: false,
            subscriptions: [],
            cards: [],
            fetchedMore: false,
            limit: 0,
            total: 0
        }
    },

    mounted () {
        this.$store.commit('payment/setShowTrial', false)
    },

    methods: {
        setLoading (value) {
            this.loading = value
        },

        async fetchMoreSubscriptions () {
            const { data } = await this.$axios.get('v1/Subscriptions')
            this.subscriptions = data.data
            this.fetchedMore = true
        },

        async createInvoice () {
            const { data } = await this.$axios.post('/v1/SubscriptionInvoice?re=true')

            if (data.status === 'error') {
                return
            }

            window.location.href = `${process.env.PAYMENT_BASE_URL}/v1/Checkout/` + data.payload.invoice.token
        },

        downloadLink (token) {
            return process.env.BASE_URL + `/v1/Invoice/download/${token}`
        }
    }
}
